module.exports = __webpack_public_path__ + "img/sb.b3481d94.svg";